@switch (name()) {
  @case ('home') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
        <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      </g>
    </svg>
  }
  @case ('tasks') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="m3 17 2 2 4-4" />
        <path d="m3 7 2 2 4-4" />
        <path d="M13 6h8" />
        <path d="M13 12h8" />
        <path d="M13 18h8" />
      </g>
    </svg>
  }
  @case ('calendar') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M8 2v4" />
        <path d="M16 2v4" />
        <rect width="18" height="18" x="3" y="4" rx="2" />
        <path d="M3 10h18" />
      </g>
    </svg>
  }
  @case ('workflow') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <circle cx="18" cy="12" r="3" />
        <circle cx="6" cy="18" r="3" />
        <circle cx="6" cy="6" r="3" />
        <path d="M9 6h2c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H9" />
        <path d="M12 12h3" />
      </g>
    </svg>
  }
  @case ('add') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g fill="none">
        <g>
          <g>
            <path
              d="M6 12H18"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M12 18V6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </svg>
  }
  @case ('chevron') {
    <svg viewBox="0 0 20 20" [class]="iconClass()">
      <g fill="none">
        <g>
          <g>
            <path
              d="M16.6004 12.5391L11.1671 7.10573C10.5254 6.46406 9.47539 6.46406 8.83372 7.10573L3.40039 12.5391"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </svg>
  }
  @case ('folder') {
    <svg viewBox="0 0 20 20" [class]="iconClass()">
      <g fill="none">
        <g>
          <g>
            <path
              d="M18.3327 9.22552V13.8755C18.3327 16.3339 16.3327 18.3339 13.8743 18.3339H6.12435C3.66602 18.3339 1.66602 16.3339 1.66602 13.8755V7.86719H18.116C18.241 8.24219 18.3077 8.62552 18.3243 9.03385C18.3327 9.09219 18.3327 9.16719 18.3327 9.22552Z"
              fill="currentColor" />
            <path
              opacity="0.4"
              d="M18.116 7.86602H1.66602V5.34935C1.66602 3.31602 3.31602 1.66602 5.34935 1.66602H7.29102C8.64935 1.66602 9.07435 2.10768 9.61602 2.83268L10.7827 4.38268C11.041 4.72435 11.0743 4.77435 11.5577 4.77435H13.8827C15.8577 4.76602 17.541 6.06602 18.116 7.86602Z"
              fill="currentColor" />
          </g>
        </g>
      </g>
    </svg>
  }
  @case ('package') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
        <path d="M12 22V12" />
        <path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7" />
        <path d="m7.5 4.27 9 5.15" />
      </g>
    </svg>
  }
  @case ('vendors') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
        <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
        <path d="M2 7h20" />
        <path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" />
      </g>
    </svg>
  }
  @case ('invoice') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
        <path d="M10 9H8" />
        <path d="M16 13H8" />
        <path d="M16 17H8" />
      </g>
    </svg>
  }
  @case ('borrowing') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M3 22h18" />
        <path d="M6 18v-7" />
        <path d="M10 18v-7" />
        <path d="M14 18v-7" />
        <path d="M18 18v-7" />
        <path d="m12 2 8 5H4z" />
      </g>
    </svg>
  }
  @case ('clock') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
      </g>
    </svg>
  }
  @case ('team') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </g>
    </svg>
  }
  @case ('building') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <rect width="16" height="20" x="4" y="2" rx="2" />
        <path d="M9 22v-4h6v4" />
        <path d="M8 6h.01" />
        <path d="M16 6h.01" />
        <path d="M12 6h.01" />
        <path d="M12 10h.01" />
        <path d="M12 14h.01" />
        <path d="M16 10h.01" />
        <path d="M16 14h.01" />
        <path d="M8 10h.01" />
        <path d="M8 14h.01" />
      </g>
    </svg>
  }
  @case ('network') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <rect x="16" y="16" width="6" height="6" rx="1" />
        <rect x="2" y="16" width="6" height="6" rx="1" />
        <rect x="9" y="2" width="6" height="6" rx="1" />
        <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" />
        <path d="M12 12V8" />
      </g>
    </svg>
  }
  @case ('bell') {
    <svg viewBox="0 0 20 20" [class]="iconClass()">
      <g fill="none">
        <path
          d="M10.0167 2.425C7.25833 2.425 5.01667 4.66667 5.01667 7.425V9.83333C5.01667 10.3417 4.8 11.1167 4.54167 11.55L3.58333 13.1417C2.99167 14.125 3.4 15.2167 4.48333 15.5833C8.075 16.7833 11.95 16.7833 15.5417 15.5833C16.55 15.25 16.9917 14.0583 16.4417 13.1417L15.4833 11.55C15.2333 11.1167 15.0167 10.3417 15.0167 9.83333V7.425C15.0167 4.675 12.7667 2.425 10.0167 2.425Z"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-miterlimit="10"
          stroke-linecap="round" />
        <path
          d="M11.5583 2.66667C11.3 2.59167 11.0333 2.53333 10.7583 2.5C9.95833 2.4 9.19167 2.45833 8.475 2.66667C8.71667 2.05 9.31667 1.61667 10.0167 1.61667C10.7167 1.61667 11.3167 2.05 11.5583 2.66667Z"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M12.5167 15.8833C12.5167 17.2583 11.3917 18.3833 10.0167 18.3833C9.33333 18.3833 8.7 18.1 8.25 17.65C7.8 17.2 7.51667 16.5667 7.51667 15.8833"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-miterlimit="10" />
        <g opacity="0"></g>
      </g>
    </svg>
  }
  @case ('sidebar') {
    <svg viewBox="0 0 24 24" [class]="iconClass()">
      <g fill="none">
        <path
          d="M21.97 15V9C21.97 4 19.97 2 14.97 2H8.97C3.97 2 1.97 4 1.97 9V15C1.97 20 3.97 22 8.97 22H14.97C19.97 22 21.97 20 21.97 15Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M7.97 2V22"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M14.97 9.44L12.41 12L14.97 14.56"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <g opacity="0"></g>
      </g>
    </svg>
  }
  @case ('user-octagon') {
    <svg viewBox="0 0 20 20" [class]="iconClass()">
      <g fill="none">
        <g opacity="0"></g>
        <path
          d="M16.2583 4.875L11.3083 2.01667C10.5 1.55 9.5 1.55 8.68333 2.01667L3.74167 4.875C2.93333 5.34167 2.43333 6.20833 2.43333 7.15V12.85C2.43333 13.7833 2.93333 14.65 3.74167 15.125L8.69167 17.9833C9.5 18.45 10.5 18.45 11.3167 17.9833L16.2667 15.125C17.075 14.6583 17.575 13.7917 17.575 12.85V7.15C17.5667 6.20833 17.0667 5.35 16.2583 4.875ZM10 6.11667C11.075 6.11667 11.9417 6.98333 11.9417 8.05833C11.9417 9.13333 11.075 10 10 10C8.925 10 8.05833 9.13333 8.05833 8.05833C8.05833 6.99167 8.925 6.11667 10 6.11667ZM12.2333 13.8833H7.76667C7.09167 13.8833 6.7 13.1333 7.075 12.575C7.64167 11.7333 8.74167 11.1667 10 11.1667C11.2583 11.1667 12.3583 11.7333 12.925 12.575C13.3 13.125 12.9 13.8833 12.2333 13.8833Z"
          fill="currentColor" />
      </g>
    </svg>
  }
  @case ('users') {
    <!-- lib-users-icon defaults its stroke to #4B4EFC -->
    <lib-users-icon [iconClass]="iconClass()" stroke="currentColor" />
  }
  @case ('layers') {
    <lib-layers-icon [iconClass]="iconClass()" />
  }
  @case ('users-group') {
    <lib-users-group-icon [iconClass]="iconClass()" />
  }
  @case ('tag') {
    <lib-tag-right-icon [iconClass]="iconClass()" />
  }
  @case ('org-chart') {
    <lib-org-chart-icon [iconClass]="iconClass()" />
  }
  @case ('shield-user') {
    <lib-shield-user-icon [iconClass]="iconClass()" />
  }
  @case ('crown') {
    <lib-crown-icon [iconClass]="iconClass()" />
  }
  @case ('document') {
    <lib-document-icon [iconClass]="iconClass()" />
  }
  @case ('shield-tick') {
    <lib-shield-tick-icon [iconClass]="iconClass()" />
  }
  @case ('table-settings') {
    <lib-table-settings-icon [iconClass]="iconClass()" />
  }
  @case ('vendor-permission') {
    <lib-vendor-permission-icon
      [iconClass]="iconClass()"
      [isActive]="active()" />
  }
  @case ('vendor-data') {
    <lib-vendor-data-icon [iconClass]="iconClass()" [isActive]="active()" />
  }
  @case ('receipt') {
    <lib-receipt-icon [iconClass]="iconClass()" />
  }
  @case ('wallet') {
    <lib-wallet-icon [iconClass]="iconClass()" />
  }
  @case ('setting') {
    <lib-setting-icon [iconClass]="iconClass()" />
  }
}
